import notificationService from './notificationService'
import { notificationTypes } from '../components/Default/NotificationCenter/constants'
import { detectContradictions } from '../components/Shared/Factsheet/contradictions/detector'
import { contradictionRules } from '../components/Shared/Factsheet/contradictions/rules'

// Single writer of the contradictory-facts notification. Detection is driven by
// the property's factsheet facts (from PropertyPage's `propertyInfo`), so it
// works on every property sub-view, not only the Edit-property view.
const NOTIFICATION_ID = 'contradictory-facts'

let lastSignature = null

/**
 * Runs contradiction detection over the given facts and pushes/dismisses the
 * contradictory-facts notification accordingly.
 *
 * Guards on the conflicting-pairs signature so re-running with the same pairs is
 * a no-op (the notification isn't needlessly re-pushed / re-marked unread).
 * Keyed on the pairs rather than the set of conflicting facts so that adding a
 * conflict between facts already involved (e.g. A–B and B–C are both present,
 * then A–C is added) still refreshes the notification and its pair count.
 *
 * @param {Object} facts state.factsheet.facts-shaped map (may be undefined)
 */
export const syncContradictionNotification = (facts) => {
  const { pairs } = detectContradictions(facts, contradictionRules)
  const signature = pairs
    .map((pair) => `${pair.ruleId}:${pair.left}:${pair.right}`)
    .sort()
    .join('|')

  if (signature === lastSignature) {
    return
  }
  lastSignature = signature

  if (pairs.length > 0) {
    notificationService.push({
      id: NOTIFICATION_ID,
      type: notificationTypes.CONTRADICTORY_FACTS,
      payload: { pairs },
    })
  } else {
    notificationService.dismiss(NOTIFICATION_ID)
  }
}

/**
 * Clears the notification and the signature tracker — call when leaving a
 * property or switching to another one, so the next property re-emits its own
 * state.
 */
export const resetContradictionNotification = () => {
  lastSignature = null
  notificationService.dismiss(NOTIFICATION_ID)
}
